import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { TribuneDto } from '../../../models/dtos/tribune.dto';
import { Errors } from '../../errors';
import getTribuneGroupRequest from './getTribuneGroup.repository';

type InitialState = {
  loading: boolean;
  data?: TribuneDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getTribuneGroup = createAsyncThunk(
  'getTribuneGroup',
  async (teamId: number) => {
    return await getTribuneGroupRequest(teamId);
  }
);

const getTribuneGroupSlice = createSlice({
  name: 'getTribuneGroup',
  initialState,
  reducers: {
    getTribuneGroupReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTribuneGroup.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getTribuneGroup.fulfilled,
      (state, action: PayloadAction<TribuneDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getTribuneGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getTribuneGroupSlice.reducer;
export const { getTribuneGroupReset } = getTribuneGroupSlice.actions;
